import { computed, type ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { newSidebarEnabled } from './newSidebarEnabled'

export const usePageTitle = (): ComputedRef<string | undefined> => {
  const route = useRoute()
  const { t } = useI18n()
  const { isEnabled: isNewSidebarEnabled } = newSidebarEnabled()

  return computed(() => {
    for (let i = route.matched.length - 1; i > 0; i--) {
      const match = route.matched[i]
      // temporary logic for feature flag evaluation
      // after the feature flag is fully deployed, we can change this back to
      // if (match?.meta?.title) return t(`core.pages.${match.meta.title}.title`)
      if (match?.meta?.title) {
        const title = match.meta.title
        // Handle billing routes with feature flag
        if (match.meta.billingRoute === true) {
          const titleKey = isNewSidebarEnabled.value
            ? `billing.${title}`
            : 'billing'
          return t(`core.pages.${titleKey}.title`)
        }
        return t(`core.pages.${title}.title`)
      }
    }

    return undefined
  })
}
